// Import extend function.
import Component from '../../../js/core/component.js';
import isVisible from '../../../js/utilities/is-visible/u-is-visible.js';

class FormValidation extends Component {

	_defaultSettings () {
		return {
			debug: false,
			maxFileSize: 20,
			maxTotalFilesSize: 25,
			fileTotalSizeOk: true,
			checkboxGroupErrorMsg: 'Välj minst ett av följande alternativ.',
			fileSizeErrorMsg: 'Filstorleken får inte överstiga 20 MB',
			totalFileSizeErrorMsg: 'Den sammanlagda filstorleken får inte överstiga 25 MB',
			formulaMaxError: 'Får inte vara mer än',
			formulaMinError: 'Får inte vara mindre än',
			errorMsgClasses: [
				'c-form-item__text',
				'c-form-item__text--error-text'
			],
			errorMsgStyleClasses: [
				'c-form__fieldset--invalid',
				'c-form-item--invalid'
			]
		};
	}

	_init () {
		if (this.inited) {
			this._log('Validation is already inited');
			return;
		}

		this.inited = true;
	}

	validateItems (items) {
		let validityStatus = [];
		items.forEach(item => {
			this.clearError(item);
			this.clearTotalFileSizeError(item);

			if (!isVisible(item)) {
				return;
			}

			validityStatus.push(this.validateItem(item));
		});

		return validityStatus;
	}

	validateItem (item, event) {
		let validity;
		let type = item.dataset.control;

		if (type === 'checkbox-group') {
			validity = this._validateCheckboxGroup(item, event);
		}
		else if (type === 'file') {
			validity = this._validateFileSize(item);
			validity = this._validateControl(item);
		}
		else if (type === 'formula') {
			validity = this._validateFormula(item);
		}
		else if (type === 'data') {
			validity = true;
		}
		else {
			validity = this._validateControl(item);
		}

		this._toggleError(item, validity, type);

		return validity;
	}

	_validateCheckboxGroup (item, event) {
		let areSiblings = this._checkIfSiblings(item, event);
		let firstControl = item.querySelector('input');
		let checked = (item.querySelectorAll('input:checked').length > 0 ? true : false);

		if (!checked && !areSiblings) {
			firstControl.setCustomValidity(this.settings.checkboxGroupErrorMsg);
			return false;
		}
		else {
			firstControl.setCustomValidity('');
			return true;
		}
	}

	_validateFileSize (item) {
		let control = item.querySelector('input');
		if (control.value) {
			let size = this._bytesToMegaBytes(control.files[0].size);

			if (size && size > this.settings.maxFileSize) {
				control.setCustomValidity(this.settings.fileSizeErrorMsg);
				return false;
			}
			else {
				return true;
			}
		}
		else {
			return true;
		}
	}

	validateTotalFileSize (fileItems) {
		let totalSize = 0;
		fileItems.forEach(item => {
			let control = item.querySelector('input');
			if (control.value) {
				totalSize += this._bytesToMegaBytes(control.files[0].size);
			}
		});

		if (totalSize > this.settings.maxTotalFilesSize) {
			this.settings.fileTotalSizeOk = false;
		}
		else {
			this.settings.fileTotalSizeOk = true;
		}

		if (this.settings.fileTotalSizeOk) {
			fileItems.forEach(item => {
				this._toggleTotalFileSizeError(item, true);
			});
		}
		else {
			fileItems.forEach(item => {
				let control = item.querySelector('input');
				if (control.value) {
					control.setCustomValidity(this.settings.totalFileSizeErrorMsg);
					this._toggleTotalFileSizeError(item, false);
				}
			});
		}
	}

	_validateControl (item) {
		let control = item.querySelector('input, select, textarea');
		return control.checkValidity();
	}

	_validateFormula (item) {
		let control = item.querySelector('dd');
		let number = control.querySelector('span');
		let value = parseInt(number.innerHTML);
		let min = item.dataset.min;
		let max = item.dataset.max;
		if (value > max) {
			control.setAttribute('data-error', `${this.settings.formulaMaxError} ${max}`);
			return false;
		}
		else if (value < min) {
			control.setAttribute('data-error', `${this.settings.formulaMinError} ${min}`);
			return false;
		}
		else {
			return true;
		}
	}

	_toggleError (item, valid, type) {
		this.clearError(item);

		if (!valid) {

			let legend = item.querySelector('legend');
			let control = item.querySelector('input, select, textarea, dd');
			let label = item.querySelector('label');
			let error = this._createError(item);

			control.setAttribute('aria-describedby', `error-${control.id}`);
			item.setAttribute('data-error', '');

			if (type === 'checkbox-group' || type === 'radio-group') {
				item.classList.add('c-form__fieldset--invalid');
				legend.insertAdjacentElement('afterend', error);
			}
			else if (type === 'checkbox' || type === 'formula') {
				item.classList.add('c-form-item--invalid');
				item.insertAdjacentElement('afterbegin', error);
			}
			else {
				item.classList.add('c-form-item--invalid');
				label.insertAdjacentElement('afterend', error);
			}
		}
	}

	_toggleTotalFileSizeError (item, valid) {
		this.clearTotalFileSizeError(item);

		if (!valid) {
			let control = item.querySelector('input, select, textarea, dd');
			let label = item.querySelector('label');
			let error = this._createError(item);

			control.setAttribute('aria-describedby', `error-${control.id}`);
			item.setAttribute('data-size-error', '');

			item.classList.add('c-form-item--invalid');
			label.insertAdjacentElement('afterend', error);
		}
	}

	_createError (item) {
		let firstControl = item.querySelector('input, select, textarea, dd');
		let errorEl = document.createElement('span');
		errorEl.classList.add(...this.settings.errorMsgClasses);
		errorEl.setAttribute('data-error-msg', '');
		if (item.dataset.control !== 'formula') {
			errorEl.innerHTML = firstControl.validationMessage;
		}
		else {
			errorEl.innerHTML = firstControl.dataset.error;
		}
		errorEl.id = `error-${firstControl.id}`;

		return errorEl;
	}

	clearError (item) {
		if (item.hasAttribute('data-error')) {
			item.removeAttribute('data-error');
			item.classList.remove(...this.settings.errorMsgStyleClasses);
			item.querySelector('[data-error-msg]').remove();

			let control = item.querySelector('input, select, textarea, dd');
			if (control.tagName !== 'DD') {
				control.setCustomValidity('');
			}
			control.removeAttribute('aria-describedby');
		}
	}

	clearTotalFileSizeError (item) {
		if (item.hasAttribute('data-size-error')) {
			item.removeAttribute('data-size-error');
			item.classList.remove(...this.settings.errorMsgStyleClasses);
			item.querySelector('[data-error-msg]').remove();

			let control = item.querySelector('input, select, textarea, dd');
			control.setCustomValidity('');
			control.removeAttribute('aria-describedby');
		}
	}

	_bytesToMegaBytes (value) {
		return value / (1024*1024);
	}

	_checkIfSiblings (item, event) {
		if (event !== undefined) {
			if (item.contains(event.relatedTarget)) {
				return true;
			}
			else {
				return false;
			}
		}
		else {
			return false;
		}
	}
}

export default FormValidation;



// WEBPACK FOOTER //
// ./components/form-elements/form/c-form-validation.js